import { type YatPageEditStates } from './types';

export const yatPageEditingAnything = ({
    editingHeading,
    editingBio,
    editingSocial,
    editingItem,
    editingLiquidID,
}: YatPageEditStates): boolean => !!(editingHeading || editingBio || editingSocial || editingItem || editingLiquidID);
